import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Identity } from '@app/shared/models/identity';
import { Observable } from 'rxjs';
import { SigninConfiguration } from '@app/shared/models/signinConfiguration';

const directoryApiVersion072021 = '07-2021';
const directoryApiVersion112023 = '11-2023';
@Injectable({
  providedIn: 'root'
})
export class DirectoryService {

  constructor(private http: HttpClient) { }

  createToken(
    data: {
      username: string;
      password: string;
    }
  ): Observable<{ identity: Identity }> {
    return this.http.post<{ identity: Identity }>('service:directory' + '/token', data);
  }

  retrieveEmailPasswordRecovery(
    data: { username: string }
  ): Observable<{}> {
    return this.http.put<{}>('service:directory' + '/password/forgot', data);
  }

  resetPassword(
    data: {
      password: string,
      id: string,
      secret: string,
      account?: string,
    }
  ): Observable<{}> {
    return this.http.put<{}>('service:directory' + '/password/reset' + '?version=' + directoryApiVersion072021, data);
  }

  getSigninConfiguration(username: string): Observable<{ configuration: SigninConfiguration }> {
    return this.http.get<{ configuration: SigninConfiguration }>('service:directory' + '/signin/configuration/' + username + '?version=' + directoryApiVersion112023);
  }

  signinSso(
    data: { username: string }
  ) {
    return this.http.post<any>('service:directory' + '/sso/signin', data);
  }
}
